export const SELECT_SHOOT_PRODUCT = 'SELECT_SHOOT_PRODUCT';

export function selectShootProduct(product) {
  return {
    type: SELECT_SHOOT_PRODUCT,
    payload: product,
  };
}
